import React, {useContext, useEffect, useMemo, useState} from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';
import {useGlobalFilter, usePagination, useSortBy, useTable,} from "react-table";
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {useHistory, useLocation} from "react-router-dom";
import {CashMonitoringMgmtApi, TerminalDataTableListMgmtApi} from "./Api";
import {terminalListContext} from "./App";
import Header from "./Header";
import AppNavbar from "./Sidebar";
import Favicon from "react-favicon";
import MetaTags from "react-meta-tags";


function CashMonitoringDashboard() {
    const {terminalList:terminalOptions, setTerminalList:setTerminalOptions}  = useContext(terminalListContext);
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const history = useHistory();
    const location = useLocation();
    const searchParams = new URLSearchParams();
    //const [terminalOptions, setTerminalOptions] = useState([]);
    const [locationOption, setLocationOption] = useState([]);
    const [selectedTerminal, setSelectedTerminal] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [settingOptions,setSettingOptions] = useState([]);
    const [selectedSetting,setSelectedSetting] = useState([]);
    const [perPage, setPerPage] = useState(20);
    const [totalRecords, setTotalRecords] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [pending, setPending] = React.useState(true);
    const [hideDirector, setHideDirector] = useState(false);




    //  Internally, customStyles will deep merges your customStyles with the default styling.
    const tableStyles = {
        rows: {
            style: {
                minHeight: '30px',
                fontSize: '10px',// override the row height
            },
        },
        cells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
                fontSize: '10px',
                wordBreak: 'break-word',
            },
            draggingStyle: {},
        },
        dataTableExt: {
            style: {
                Width:'40px',
            },
        },
    };

    const handleTerminalTableRowClick = (data) => {
        history.push({
            pathname: "/termManagement/terMinalDetails",
            search: `terminalID=${data}`,
        });
    };

    /**Custom table code*/
    const datacolumns = [
        {
            name: 'TerminalID',
            selector: row => row.terminalID+'('+(row.cassette+1)+')',
            sortable: true,
            center: true,
        },
        {
            name: 'Location ',
            selector: row => row.locationName,
            sortable: true,

        },
        {
            name: 'Denom.',
            selector: row => (row.denom),
            sortable: true,
            center: true,
        },
        {
            name: 'Loaded ',
            selector: row => row.lastAmountBill,
            sortable: true,
        },
        {
            name: 'Dispensed ',
            selector: row => row.dispensed,
            sortable: true,
            center: true,
        },
        {
            name: 'Remaining ',
            selector: row => row.remaining,
            sortable: true,
            center: true,
        },
        {
            name: 'Last Heartbeat ',
            selector: row => row.lastheartBeat,
            sortable: true,
        },
        {
            name: 'Last Trans.',
            selector: row => row.lastTransTime,
            sortable: true,
        },
        {
            name: 'Last Load. Date',
            selector: row => row.lastLoadDate,
            sortable: true,
        },
        {
            name: 'Total cassette',
            selector: row => row.totalCassetteValue,
            sortable: true,
            omit: {hideDirector},
        },
        {
            name: 'Error ',
            width: "70px",
            center: true,
            selector: row => row.errorStatusIcon.includes("GOOD")?<img
                src="/assets/images/icons/shield-green.png"
                height="13"
                width="13"
            />:<img
                src="/assets/images/icons/shield-red.png"
                height="13"
                width="13"
            />,
            fixedHeader:true,
        },
    ];


    /**End of Custom Data table*/
    const columns = useMemo(
        () => [
            {
                Header: "Error",
                accessor: "",
                Cell: (props) => {
                    return (
                        <img
                            src="/assets/images/icons/shield-grey.png"
                            height="16"
                            width="16"
                        />
                    );
                },
            },
            {
                Header: "Cash",
                accessor: "",
                Cell: (props) => {
                    return (
                        <img
                            src="/assets/images/icons/shield-red.png"
                            height="16"
                            width="16"
                        />
                    );
                },
            },
            {
                Header: "Terminal Id",
                accessor: "terminalID",
                Cell: (props) => (
                    <h6>
                        {props.value}
                    </h6>
                ),
            },
            {
                Header: "Cassette",
                accessor: "d1MediaValue",
            },
            {
                Header: "Location Name",
                accessor: "locationName",
            },
            {
                Header: "Denomination",
                accessor: "lastTransData",
                Cell: ({ value }) => {
                    return Math.random().toString();
                },
            },
            {
                Header: "Last Bill USed",
                accessor: "d1CurrencyCode",
            },
            {
                Header: "Dispensed",
                accessor: "timeZoneName",
            },
            {
                Header: "Remaining",
                accessor: "",
            },
            {
                Header: "Last Heartbeat",
                accessor: "lastMgmtTime",
            },
            {
                Header: "Last Tran",
                accessor: "lastTransTime",
            },
            {
                Header: "Last Load Date",
                accessor: "d1LastReplenish",
            }
        ],
        []
    );

    const handleSettingsSelection = async (e) => {
        setSelectedSetting(e)
    };
    useEffect(() => {
        console.log(" change cols on changes ",selectedSetting)
    }, [selectedSetting]);
    // const data = useMemo(()=>[],[])
    const [data, setData] = useState([]);
    useEffect(() => {
        const fetchResults = async () => {
            let result = await axios.get(`${CashMonitoringMgmtApi}?id=${loggedUserStorage}&searchCriteria=""&lastTxn=10&pageSize=${perPage}&currentPage=${currentPage}&sortColumn=TerminalID&sortOrder=DESC`,{
                mode: 'no-cors' // 'cors' by default
            });
            console.log("END OF DATATABLE RETRIEVE");
            let resultTerminal = await axios.get(`${TerminalDataTableListMgmtApi}?id=${loggedUserStorage}&parentUserId=${loggedUserStorage}`,{
                mode: 'no-cors' // 'cors' by default
            });

            console.log("END OF TERMINAL RETRIEVE");


            setData(result.data.response);



            setTerminalOptions(resultTerminal?.data?.response);
            setTotalRecords(resultTerminal?.data?.response?.length);


            setPending(false);
        };
        fetchResults();

        return () => {
            //setTerminalOptions([]);
            setLocationOption([]);
        };
    }, [currentPage]);

    const exportPDF = () => {
        const unit = "pt";
        const size = "A4";
        const orientation = "portrait";

        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(15);

        const title = "Terminal Details";
        const headers = [["terminalID", "locationName"]];

        const pdata = data?.map((elt) => [...Object.values(elt)]);

        let content = {
            startY: 50,
            head: headers,
            body: pdata,
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save("report.pdf");
    };

    function Table({ columns, data }) {
        const {
            getTableProps,
            getTableBodyProps,
            headerGroups,
            page,
            nextPage,
            previousPage,
            canNextPage,
            canPreviousPage,
            setGlobalFilter,
            state: { pageIndex, pageSize, globalFilter },
            prepareRow,
        } = useTable(
            {
                columns,
                data,
                initialState: { pageSize: 2 },
            },
            useGlobalFilter,
            useSortBy,
            usePagination
        );



        return (<></>

        );
    }


    /*if(pending){
        return <div className="spinner-container">
            <div className="loading-spinner">
            </div>
        </div>
    }*/
    return (
        <div className="tab-pane" id="tb_terminal_mgmt" role="tabpanel">
            <body data-sidebar="colored">
            <div id="layout-wrapper">
                <Header/>
                <AppNavbar/>
            </div>
            <div className="main-content">
                <Favicon url='https://passporttechnology.com/images/base/favicon-16x16.png' />
                <MetaTags>
                    <title>DataStream Version 2.0</title>
                    <meta name="description" content="Some description." />
                    <meta property="og:title" content="DataStream Version 2.0" />
                </MetaTags>
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-flex align-items-center justify-content-between">
                                    <h4 className="mb-0">Cash Monitoring Dashboard</h4>
                                </div>
                            </div>
                        </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        <DataTableExtensions
                            columns={datacolumns}
                            data={data}
                            print={false}
                            export={false}
                            exportHeaders = {true}
                            customStyles={tableStyles}
                        >

                            <DataTable
                                columns={datacolumns}
                                data={data}
                                noHeader
                                pagination
                                highlightOnHover
                                pointerOnHover
                                paginationServer
                                paginationTotalRows={totalRecords}
                                paginationPerPage={perPage}
                                paginationComponentOptions={{
                                    noRowsPerPage: true
                                }}
                                progressPending={pending}
                                onChangePage={page => setCurrentPage(page)}
                                customStyles={tableStyles}
                            />
                        </DataTableExtensions>
                    </div>
                </div>
            </div>
                    </div>
                </div>
            </div>
            </body>
        </div>
    );
}

export default CashMonitoringDashboard;
